import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=73a252aa"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a252aa')) {
      api.createRecord('73a252aa', component.options)
    } else {
      api.reload('73a252aa', component.options)
    }
    module.hot.accept("./UploadFile.vue?vue&type=template&id=73a252aa", function () {
      api.rerender('73a252aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/UploadFile.vue"
export default component.exports